//
import { ColumnDef } from "@tanstack/react-table"
import moment from "moment"
//
import { ChipStyled } from "src/shared/components"
import { capitalizeFirstLetter } from "src/shared/utils/data-helpers"
import { IconButton, Tooltip } from "@mui/material"
import EditIcon from "@mui/icons-material/Edit"
import PointOfSaleIcon from "@mui/icons-material/PointOfSale"
import ReceiptIcon from "@mui/icons-material/Receipt"
import { LocationRegisterType, PrintModeType } from "src/graphql/quark/quark.type"

export const getRegisterListTableColumns = ({
  onEdit,
  hasPermission
}: {
  onEdit?: (register: any) => void
  hasPermission: (permission: string) => boolean
}): ColumnDef<any, any>[] => {
  return [
    {
      header: "ID",
      accessorKey: "secondaryId"
    },
    {
      header: "Name",
      accessorKey: "name"
    },
    {
      header: "Type",
      accessorKey: "type",
      cell: ({ row }) => (
        <ChipStyled
          label={capitalizeFirstLetter((row.original.type ?? "").toString().toLowerCase())}
          size="small"
          variant="filled"
          color={(getRegisterTypeColor(row.original.type) as any) ?? "default"}
          icon={<PointOfSaleIcon fontSize="small" />}
        />
      )
    },
    {
      header: "Status",
      accessorKey: "status",
      cell: ({ row }) => (
        <ChipStyled
          label={capitalizeFirstLetter((row.original.status ?? "").toString().toLowerCase())}
          size="small"
          variant="filled"
          color="success"
        />
      )
    },
    {
      header: "Print Mode",
      accessorKey: "printMode",
      cell: ({ row }) => (
        <ChipStyled
          label={capitalizeFirstLetter((row.original.printMode ?? "").toString().toLowerCase())}
          size="small"
          variant="outlined"
          color={(getPrintModeColor(row.original.printMode) as any) ?? "default"}
          icon={<ReceiptIcon fontSize="small" />}
        />
      )
    },
    {
      header: "Currency",
      accessorKey: "currency",
      cell: ({ row }) => (
        <ChipStyled label={row.original.currency || "USD"} size="small" variant="outlined" color="success" />
      )
    },
    {
      header: "Terminal Tax ID",
      accessorKey: "terminalTaxId"
    },
    {
      header: "Created At",
      accessorKey: "createdAt",
      accessorFn: (row) => moment(row?.createdAt).format("lll")
    },
    {
      header: "Updated At",
      accessorKey: "updatedAt",
      accessorFn: (row) => moment(row?.updatedAt).format("lll")
    },
    {
      header: "Actions",
      enableHiding: false,
      meta: {
        textAlign: "center",
        headerAlign: "center",
        width: "100px"
      },
      cell: ({ row }) => (
        <Tooltip
          title={hasPermission("system:register-management:update") ? "Edit Register" : "You don't have permission"}
        >
          <IconButton
            disabled={!hasPermission("system:register-management:update")}
            onClick={() => onEdit?.(row.original)}
            size="small"
            sx={{
              color: "primary.main",
              "&:hover": {
                backgroundColor: "primary.light",
                color: "white"
              }
            }}
          >
            <EditIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )
    }
  ]
}

const getRegisterTypeColor = (type?: string) => {
  switch (type) {
    case LocationRegisterType.SalesRegister:
      return "primary"
    case LocationRegisterType.CartRegister:
      return "success"
    default:
      return "default"
  }
}
const getPrintModeColor = (printMode?: string) => {
  switch (printMode) {
    case PrintModeType.Thermal:
      return "primary"
    default:
      return "default"
  }
}
